<template>
  <div class="tab">
    <div
      class="tab-title"
      v-for="(item, index) in tabList"
      :key="item.label"
      :class="{ active: currentIndex === index }"
      @click="handleClick(item.value, index)"
    >
      {{ item.label }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      currentIndex: 0
    };
  },
  methods: {
    handleClick(value, index) {
      this.currentIndex = index;
      this.$emit("tabChange", value);
    }
  }
};
</script>

<style lang="scss" scoped>
.tab {
  display: flex;
  margin: 10px 0;
  border-bottom: 2px solid rgb(228, 231, 237);
  height: 35px;

  .tab-title {
    height: 35px;
    margin-right: 30px;
    padding-bottom: 15px;
    font-size: 16px;
    cursor: pointer;
    &:hover {
      color: rgb(64, 158, 255);
    }
  }
}
.active {
  color: rgb(64, 158, 255);
  padding-bottom: 10px;
  border-bottom: 2px solid rgb(64, 158, 255);
}
</style>



// WEBPACK FOOTER //
// src/components/tab/Tab.vue